import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo/dark.png'


const _withScopeId = n => (_pushScopeId("data-v-5ba7ba29"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "leftpart" }
const _hoisted_2 = { class: "leftpart_inner" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = { class: "menu" }
const _hoisted_6 = { class: "copyright" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "relative" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"padding-right":"26px"} }, " Crafted with "),
  /*#__PURE__*/_createElementVNode("span", { class: "heart" }),
  /*#__PURE__*/_createElementVNode("span", null, " by me ")
], -1))
const _hoisted_9 = { class: "rightpart" }
const _hoisted_10 = { class: "rightpart_in" }
const _hoisted_11 = { class: "theme_a_section" }
const _hoisted_12 = { class: "container" }
const _hoisted_13 = { class: "tabcontent" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_MenuItem, {
            text: "Home",
            link: "/",
            icon: _ctx.home
          }, null, 8, ["icon"]),
          _createVNode(_component_MenuItem, {
            text: "Experiences",
            link: "experiences",
            icon: _ctx.avatar
          }, null, 8, ["icon"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, [
            _createElementVNode("span", null, [
              _createTextVNode(" © " + _toDisplayString(new Date().getFullYear()) + " Ahmed Allam.", 1),
              _hoisted_7
            ]),
            _hoisted_8
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_router_view)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}